import { render, staticRenderFns } from "./Inlet.vue?vue&type=template&id=8fbcf6b6&scoped=true&"
import script from "./Inlet.vue?vue&type=script&lang=js&"
export * from "./Inlet.vue?vue&type=script&lang=js&"
import style0 from "./Inlet.vue?vue&type=style&index=0&id=8fbcf6b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbcf6b6",
  null
  
)

export default component.exports